<div class="row justify-content-center">
  <div class="col-12">

    <!-- Page Title -->
    <div class="row mt-5">
      <div class="col-12">
        <h1 class="header-title">Création d'un nouveau questionnaire de collecte de données client</h1>
      </div>
    </div>


    <div class="row">
      <div class="col-12">
        <app-alert-messages></app-alert-messages>
      </div>
    </div>

    <!-- Name -->
    <div class="row mt-5">
      <div class="col-12">
        <label class="form-label"> <strong> Nom du client </strong></label>
        <input [class.is-invalid]="this.form.formElements.clientName.state === 'ERROR'"
          [class.is-valid]="this.form.formElements.clientName.state === 'VALID' || this.form.formElements.clientName.lifecycleStatus === 'SENDING'"
          [formControl]="getClientNameFormControl()"
          [readOnly]="this.form.formElements.clientName.lifecycleStatus === 'SENDING' || this.form.formElements.clientName.lifecycleStatus === 'LOADING'"
          class="form-control"
          placeholder="Jean Tremblay"
          type="text">
        <div class="form-text">Entrez le nom complet de votre client</div>

        @if (this.form.formElements.clientName.helpMessages.length != 0) {
          <div
            [class.invalid-feedback]="this.form.formElements.clientName.state === 'ERROR'"
            [class.valid-feedback]="this.form.formElements.clientName.state === 'VALID'">
            @for (helpMessage of this.form.formElements.clientName.helpMessages; track helpMessage) {
              <p>{{ helpMessage }}</p>
            }
          </div>
        }
      </div>
    </div>

    <!-- Email -->
    <div class="row mt-5">
      <div class="col-12">
        <label class="form-label"> <strong> Courriel du client </strong></label>
        <input [class.is-invalid]="this.form.formElements.clientEmail.state === 'ERROR'"
          [class.is-valid]="this.form.formElements.clientEmail.state === 'VALID' || this.form.formElements.clientEmail.lifecycleStatus === 'SENDING'"
          [formControl]="getClientEmailFormControl()"
          [readOnly]="this.form.formElements.clientEmail.lifecycleStatus === 'SENDING' || this.form.formElements.clientEmail.lifecycleStatus === 'LOADING'"
          class="form-control"
          placeholder="jean.tremblay@gmail.com"
          type="text">
        <div class="form-text">Entrez le courriel de votre client</div>

        @if (this.form.formElements.clientEmail.helpMessages.length != 0) {
          <div
            [class.invalid-feedback]="this.form.formElements.clientEmail.state === 'ERROR'"
            [class.valid-feedback]="this.form.formElements.clientEmail.state === 'VALID'">
            @for (helpMessage of this.form.formElements.clientEmail.helpMessages; track helpMessage) {
              <p>{{ helpMessage }}</p>
            }
          </div>
        }
      </div>
    </div>

    <!-- Calculation choices -->
    <div class="row mt-5">
      <h4> Choisir le type de questionnaire que vous voulez créer pour ce client </h4>
      <div class="col-12 d-flex flex-column">
        @for (clientQuestionnaireDetails of this.clientQuestionnaireDetails; track clientQuestionnaireDetails) {
          <label
            id="client_intake_form_{{ clientQuestionnaireDetails.value }}">
            <input [formControl]="getKeynameEnumFormControl()" class="card-input-element" type="radio"
              value="{{ clientQuestionnaireDetails.value}}">
            <div class="card card-input mb-3">
              <div class="row g-0">
                <div class="col-md-2 col-lg-1 d-flex align-items-center justify-content-center">
                  <span> <i class="fas fa-check-circle"></i> </span>
                </div>
                <div class="col-md-10 col-lg-11">
                  <div class="card-body">
                    <h5 class="card-title"><strong> {{ clientQuestionnaireDetails.title }} </strong></h5>
                    <p class="card-text">{{ clientQuestionnaireDetails.text }}</p>
                  </div>
                </div>
              </div>
            </div>
          </label>
        }
      </div>
    </div>

    <!-- Submit button -->
    <div class="row">
      <div class="col-12">
        <magieno-button [button]="this.form.getButton('CREATE')"></magieno-button>
      </div>
    </div>

  </div>
</div> <!-- / .row -->